import { FC, useContext, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";
import { MainButton } from "..";
import { SocketContext, TeamContext } from "../../../context";

const ConnectionFailedPage: FC<{}> = () => {
    const { reConnectToServer, roomUsers } = useContext(TeamContext);
    const { socket } = useContext(SocketContext);
    const { t } = useTranslation();
    const windowLocationHref = window.location.href;
    const urlPathChunks = windowLocationHref.split("/");
    const urlTokenExtracted = urlPathChunks[urlPathChunks.length-1];
    const doesUrlIncludeSpectator = windowLocationHref.includes("spectator");
    let history = useHistory();

    const forceSpectator = () => {
      let payload = {
          matchId: urlTokenExtracted,
          gameId: 1,
          spectator: {
              email: localStorage.getItem(urlTokenExtracted),
          }
     }
      socket?.emit("reconnection", {email: localStorage.getItem(urlTokenExtracted), matchId: urlTokenExtracted, spectator: doesUrlIncludeSpectator});
      doesUrlIncludeSpectator && socket?.emit("joinRoomSpectator", payload );
      roomUsers();
  }

    useEffect(() => {
      forceRefresh();
    }, [reConnectToServer])

    const forceRefresh = () => {
        reConnectToServer();
        doesUrlIncludeSpectator && forceSpectator();
    }

    const redirectToForceReJoinPage = () => {
        history.push("/force/" + urlTokenExtracted); 
        window.location.reload();
    }

    const renderButtonWithLable = (buttonLabel: string, passedFunction: any, buttonText: string) => {
      return (
        <div>
          <div style={{width: "23vw", minWidth: "250px", margin: "20px 15px 5px"}}>
            {buttonLabel}: 
          </div>
          <div style={{width: "20vw", minWidth: "200px", margin: "5px 15px"}}> 
             <MainButton text={buttonText} type="big" clickHandler={() => passedFunction()} disabled={false} />
          </div>
        </div>
      )
    }

    return (
      <div style={{width: "20vw", height: "100vh", minWidth: "300px", display: "flex", flexDirection: "column", justifyContent: "center", color: "white", position: "absolute", zIndex: 5, backgroundColor: "rgb(3,4,5,0.5)"}} className="fredokaone_font"> 
          {/* {renderButtonWithLable(t("reJoinByForce1Text"), redirectToForceReJoinPage, t("forceReJoinText"))} */}
          {renderButtonWithLable(t("reJoinByForce1Text"), forceRefresh, t("reConnectToServerText"))}
      </div>
    )
}

export default ConnectionFailedPage;